import { Fragment } from 'react'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  FunctionField,
  SelectInput,
  DateInput,
  useListContext,
} from 'react-admin'

import FilterComponent from '../../components/Filter'

const REFUND_STATUSES = {
  pending: 'Chờ xử lý',
  processed: 'Đã xử lý',
}

const formatAmount = (amount, currency = 'VND') => {
  if (!amount) return '0'
  const roundedAmount = Math.round(amount)
  const formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: currency || 'VND',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  console.log('currency', currency)
  return formatter.format(roundedAmount)
}

const RefundFilter = props => {
  const { filterValues } = useListContext()
  return (
    <FilterComponent {...props}>
      <SelectInput
        label="Filter"
        source="date"
        choices={[
          { id: 'all', name: 'All' },
          { id: 'this_month', name: 'This month' },
          { id: 'last_month', name: 'Last month' },
          { id: 'custom', name: 'Choose date' },
        ]}
        alwaysOn
        allowEmpty={false}
      />
      {'custom' === filterValues.date && (
        <DateInput label="From date" source="fromDate" alwaysOn />
      )}
      {'custom' === filterValues.date && (
        <DateInput label="To date" source="toDate" alwaysOn />
      )}
      <SelectInput
        label="Status"
        source="status"
        choices={[
          { id: 'pending', name: 'Chờ xử lý' },
          { id: 'processed', name: 'Đã xử lý' },
        ]}
        alwaysOn
        allowEmpty
      />
    </FilterComponent>
  )
}

const RefundList = props => {
  return (
    <Fragment>
      <List
        {...props}
        sort={{ field: 'id', order: 'DESC' }}
        filters={<RefundFilter />}
        bulkActionButtons={false}>
        <Datagrid bulkActionButtons={false} rowClick="edit">
          <TextField source="id" />
          <TextField label="User ID" source="userId" />
          <ReferenceField
            label="User"
            source="userId"
            reference="user-details"
            link="show">
            <TextField source="username" />
          </ReferenceField>
          <FunctionField
            label="Số tiền"
            source="amount"
            render={record => formatAmount(record.amount, record.currency)}
          />
          <DateField label="Ngày refund" source="refundDate" />
          <TextField label="Mã subscription" source="subscriptionId" />
          <FunctionField
            label="Trạng thái"
            source="status"
            render={record =>
              REFUND_STATUSES[record.status] || record.status || 'Chờ xử lý'
            }
          />
          <TextField label="Ghi chú" source="note" emptyText="-" />
          <ReferenceField
            label="Người xử lý"
            source="processedBy"
            reference="users"
            allowEmpty>
            <TextField source="name" />
          </ReferenceField>
          <DateField label="Ngày tạo" source="createdAt" />
          <DateField label="Ngày cập nhật" source="updatedAt" />
        </Datagrid>
      </List>
    </Fragment>
  )
}

export default RefundList
